import { RedirectKeys } from "@entrilia/shared/auth/authTypes";
import { getVariables } from "../variables";

export const redirectToSignin = () => {
  const currentUrl = new URL(window.location.href);
  const urlParams = new URLSearchParams();
  const prompt = currentUrl.searchParams.get(RedirectKeys.Prompt);
  if (prompt !== null) {
    urlParams.set(RedirectKeys.Prompt, prompt);
    currentUrl.searchParams.delete(RedirectKeys.Prompt);
  }

  urlParams.set(
    RedirectKeys.State,
    JSON.stringify({ origin: currentUrl.origin, originalPath: `${currentUrl.pathname}${currentUrl.search}` })
  );

  window.location.href = `${getVariables().LOGIN_APP_URI}/signin?${urlParams.toString()}`;
};

export const redirectToLogout = () => {
  window.location.href = `${getVariables().LOGIN_APP_URI}/logout`;
};

export const redirectToEmailVerification = () => {
  window.location.href = `${getVariables().LOGIN_APP_URI}/verificationnotcompleted`;
};
